/* eslint-disable react/prop-types */
export const getEncounterStatus = (encounter, encounterPhase) => {
  let defaultStatus;

  switch (encounterPhase) {
    case 'in-visit':
      defaultStatus = encounter?.in_visit_status;
      break;
    case 'pre-chart':
      defaultStatus = encounter?.pre_chart_status;
      break;
    case 'after-visit':
      defaultStatus = encounter?.after_visit_status;
      break;
    case 'dictate':
      defaultStatus = 'dictate';
      break;
  }
  return defaultStatus;
};

export const formatEncounterStatus = (encounter) => {
  if (!encounter) {
    return { displayStatus: '', color: '' };
  }

  const preChartStatus = getEncounterStatus(encounter, 'pre-chart');
  const inVisitStatus = getEncounterStatus(encounter, 'in-visit');
  let displayStatus = inVisitStatus;
  if (inVisitStatus == 'new' && preChartStatus && preChartStatus !== 'new') {
    displayStatus = `pre-chart ${preChartStatus}`;
  } else {
    displayStatus = inVisitStatus;
  }
  let color;

  switch (displayStatus) {
    case 'inprogress':
      color = '#FF6F00';
      displayStatus = 'In Progress';
      break;
    case 'pre-chart inprogress':
      color = '#FF6F00';
      displayStatus = 'Pre-chart in progress';
      break;
    case 'pre-chart clinical-note-generated':
      color = '#5667E9';
      displayStatus = 'Pre-chart summary available';
      break;
    case 'completed':
      color = '#16a878';
      displayStatus = 'Completed';
      break;
    case 'pre-chart completed':
      color = '#16a878';
      displayStatus = 'Pre-chart completed';
      break;
    case 'new':
      color = '#5a8dda';
      displayStatus = 'Not Started';
      break;
    case 'pre-chart summary_inprogress':
      color = '#562e00';
      displayStatus = 'Pre-chart generating';
      break;
    default:
      color = '#562e00';
      displayStatus = 'Generating';
  }

  if (encounter?.encounter_status === 'saved_to_ehr') {
    color = '#292929';
    displayStatus = 'Saved to EHR';
  }
  if (encounter?.encounter_status === 'copied_to_ehr') {
    color = '#7048E8';
    displayStatus = 'Copied to EHR';
  }

  return { displayStatus: displayStatus, color: color };
};

export const getFullEncounterStatus = (encounter, humanScribeStatus) => {
  const encounterStatus = encounter?.encounter_status;

  // Create a lookup object from humanScribeStatus for quick access
  const statusMapping = humanScribeStatus?.aura_status_mapping?.reduce(
    (map, status) => {
      map[status.status_id] = {
        name: status.status_name,
        color: status.color,
      };
      return map;
    },
    {}
  );
  if (
    encounter?.in_visit_status != 'completed' ||
    encounterStatus == null ||
    statusMapping == null
  ) {
    const { displayStatus, color } = formatEncounterStatus(encounter);
    return {
      fullEncounterStatus: displayStatus,
      fullEncounterColor: color,
    };
  }

  // Retrieve the status info or use a default if not found
  const { name = 'UNKNOWN', color = '#562e00' } =
    statusMapping[encounterStatus] || {};
  return {
    fullEncounterStatus: name,
    fullEncounterColor: color,
  };
};

export const roundToNext15Minutes = (localTime) => {
  const minutes = localTime.minutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;

  // Set the rounded minutes and reset seconds/milliseconds
  return localTime.minutes(roundedMinutes).seconds(0).milliseconds(0);
};
